import { render } from "./inPersonButton.vue?vue&type=template&id=6b1fad52"
import script from "./inPersonButton.vue?vue&type=script&lang=js"
export * from "./inPersonButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__